// Recuperer les info de l'instance pour certains champs
const userInfo = JSON.parse(localStorage.getItem("user"));

// Nom du user pour remplir representative
const userName = `${userInfo?.firstname} ${userInfo?.lastname}`

const emptyDataLDE = {
  id: null,
  UserId: null,
  productName: "LDE",
  productId: "3",
  phoneNumber: null,
  quoteCode: null,
  projectNumber: null,
  quoteDate: null,
  isActive: true,
  quotationStatus: "Active",
  estimativeShippingDate: new Date(),
  unitaryPriceCDN: null,
  unitaryPriceUSD: null,
  unitDesignation: null,
  numberUnits: 1,
  exchangeRate: null,
  shipping: "Not Included",
  representative: userName,
  ///////////// CHAMPS PROPRE À LDE /////////////
  airFlowType: "Constant",
  application: "100% OA",
  CFMHighVolume: null, 
  CFMMinVolume: null, 
  installation: "Outdoor", 
  temperatureRise: "90",
  externalStaticPressure: "1",
  gasType: "Natural Gas",
  dischargeLocation: "Bottom", 
  motorSecurityFactor: "1.1", 
  voltage: "575/3/60", 
  controls: "Included", 
  heatControl: "Discharge",
  damper: "Uninsulated",
  filterLocation: "In Hood",
  dirtyFilterContact: "Not Included", 
  coolingSection: "Not Included", 
  ////////////////////////////////////////////////
  shipping: "Not Included",
  country: null,
  province: null,
  city: null,
  startUp: "Not Included",
  roofCurb: "Not Included",
  margin: "0",
  leadTime: null,
  SubmittedBy: null,
  CompanyOffice: null,
  unitModel: null,
  mechanicalCode: null,
  curbDrawing: null,
  electricalDiagram: null,
  unitaryPrice: null,
  unitaryShippingPrice: null,
  unitaryStartUpPrice: null,
  totalUnitaryPrice: null,
  isPriceValid: false,
  userCreation: null,
  dateCreation: new Date(),
  userModification: null,
  projectNumber: null,
  dateModification: new Date(),
  };

export default emptyDataLDE;

  
  